import React, { useState } from 'react'
import FileUploader from 'devextreme-react/file-uploader'
import Button from 'devextreme-react/button'
import mime from 'mime'
import notify from '../../utils/notify'
import { minifiyUrl } from '../../utils/model-data'

const acceptTypesByExtention = (extensions: string[]) => {
	return extensions
		.flatMap(ext => {
			const mimeType = mime.getType(ext)
			return [mimeType, ext]
		})
		.join(', ')
}

export default function UploadField(props: any) {
	const { folder, model, name, multiple, value, setValue, settings, uploadFolder, onStartUpload } = props
	const { extensions, required } = settings

	const [labelText, setLabelText] = useState(value || '')

	return (
		<div style={{ position: 'relative' }}>
			<FileUploader
				selectButtonText="SELECT"
				labelText={minifiyUrl(labelText)}
				multiple={multiple ?? false}
				uploadMode="instantly"
				uploadUrl={`${API_FIBER_URL}/view/upload`}
				onBeforeSend={(e: any) => {
					e.request.withCredentials = true
				}}
				uploadCustomData={{ folder, model, field: name, uploadFolder }}
				onUploadStarted={() => {
					if (onStartUpload) {
						onStartUpload()
					}
					notify('Uploading file...', 'info')
				}}
				onUploaded={(e: any) => {
					try {
						const data = JSON.parse(e.request.response)
						if (data.success) {
							setLabelText(data.filename)
							setValue(data.filename)
							notify('File uploaded successfully!', 'success')
						} else {
							notify(data.message || 'Upload failed', 'error')
						}
					} catch (error) {
						notify('Error parsing upload response', 'error')
					}
				}}
				onUploadError={(e: any) => {
					try {
						const data = JSON.parse(e.request.response)
						notify(data.message || 'Upload failed', 'error')
					} catch (error) {
						notify('Upload failed: ' + (e.error?.message || 'Unknown error'), 'error')
					}
				}}
				{...(extensions &&
					extensions.length > 0 && {
						allowedFileExtensions: extensions,
						accept: acceptTypesByExtention(extensions),
					})}
			/>
			{!required && labelText && (
				<Button
					style={{ position: 'absolute', right: '0px', top: '0px', transform: 'scale(0.5)' }}
					icon="clear"
					hint="Unlink file"
					disabled={false}
					onClick={async () => {
						setLabelText('')
						setValue('')
					}}
				/>
			)}
		</div>
	)
}
